import React from 'react'
import { NaviGate } from "../../../Utility/function";
import { useNavigate } from "react-router-dom";

const Rawmaterial = () => {
    const navigate = useNavigate();
    let menuItems = [

        {
            name: "Raw Materials",
            route: "/raw_materials",
            icon: "bi bi-tag",
            url: "assets/images/menu/subcat.png",
        },
        // {
        //     name: "ingridents",
        //     route: "/ingridents",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },
        {
            name: "RM Product Transection",
            route: "/raw_transection",
            icon: "bi bi-tag",
            url: "assets/images/menu/subcat.png",
        },
        {
            name: "Purchase",
            route: "/purchase",
            icon: "bi bi-cart-check",
            url: "assets/images/menu/purchase.png",
        },
        // {
        //     name: "Purchase Order",
        //     route: "/purchase_order",
        //     icon: "bi bi-cart-check",
        //     url: "assets/images/menu/Purchase order.png",
        // },
        // {
        //     name: "Supplier ",
        //     route: "/Supplier_list",
        //     icon: "bi bi-tag",
        //     url: "assets/images/menu/subcat.png",
        // },
        {
            name: "RawMaterial Expiry",
            route: "/Rawmetrial_expiry",
            icon: "bi bi-currency-exchange",
            url: "assets/images/menu/finace.png",
        },

    ]
    const handleCardClick = (route) => {
        navigate(route);
    };
    return (
        <div className="my-4 mx-3 pb-5 ">
            <NaviGate />
            <div className="product-grid row  d-flex justify-content-center align-items-center" style={{ padding: "10 25px", minHeight: "80vh", }}>
                {menuItems
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2 " key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body ">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    )
}

export default Rawmaterial





